import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import {
  IconContainer,
  StyleContainerPlaceholder,
  StyledContainer,
} from "./session-sent-badge.style";
import { SessionSentBadgeColor } from "./session-sent-badge.types";

type Props = {
  label: string;
  isVisible?: boolean;
  color?: SessionSentBadgeColor;
};

export const MDSSessionSentBadge = ({ color, isVisible, label }: Props) => {
  if (!isVisible) {
    return <StyleContainerPlaceholder />;
  }

  return (
    <StyledContainer color={color}>
      <IconContainer>
        <MdsIcon kind={MdsIconKind.Check} />
      </IconContainer>{" "}
      {label}
    </StyledContainer>
  );
};
